import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import Autocomplete from "../../elements/Select/Autocomplete";
import { getCandidatesRole } from '../../store/actions/candidate';

const RoleDropDown = ({selectedData = "", handleChange}) => {

    const dispatch = useDispatch();

    const {candidatesRole} = useSelector((state) => {
        return {
            candidatesRole: state.candidates?.candidatesRole
        }
    });

    useEffect(() => {
        dispatch(getCandidatesRole())
    }, [])

    return (
        <Autocomplete
            data={candidatesRole}
            displayLabel={"title"}
            selectedData={selectedData}
            equalKey={"slug"}
            minWidth={"auto"}
            onChange={handleChange}
            inputProps={{
                type: "text",
                title: "Role",
                variant: "outlined",
                placeholder: "Role",
                autoFocus: true,
                noMargin: true,
                InputProps: {
                    style: {minHeight: 45}
                },
                InputLabelProps: {
                    shrink: false,
                },
                size: "small"
            }}
        />
    )
}

export default RoleDropDown;
